// frontend/src/modules/onboarding/OnboardingProvider.tsx
//
// One onboarding state for the whole dashboard subtree.
//
// WHY THIS EXISTS: the guide's two consumers live at different heights in the
// tree. <GetStartedPanel> is on the /dashboard INDEX route, so it unmounts the
// moment a walkthrough navigates anywhere; <OnboardingAutoAdvance> has to
// outlive that navigation because its whole job is to notice "you just did the
// thing" and close the tour. Holding the state here — above the route that
// unmounts — is what makes that possible, and doing it in a context means the
// two consumers share a single GET rather than issuing one apiece.

import * as React from 'react';
import { useOnboardingState, type OnboardingApi } from './useOnboarding';

const OnboardingContext = React.createContext<OnboardingApi | null>(null);

export function OnboardingProvider({ children }: { children: React.ReactNode }) {
  const value = useOnboardingState();
  return <OnboardingContext.Provider value={value}>{children}</OnboardingContext.Provider>;
}

export function useOnboarding(): OnboardingApi {
  const ctx = React.useContext(OnboardingContext);
  if (!ctx) throw new Error('useOnboarding must be used inside <OnboardingProvider>');
  return ctx;
}
